module.exports = __webpack_public_path__ + "img/contact.bcd0c2d3.svg";